import {add_classes, remove_classes} from './classlist';

function add(collection, class_list) {
  Array.from(collection).forEach(el => add_classes(el, class_list));
}

function remove(collection, class_list) {
  Array.from(collection).forEach(el => remove_classes(el, class_list));
}

export {
  add,
  remove,
};
